import { FormGroup } from "@mui/material";
import { IntegerRangeFilter } from "../../../../../../components/dataGridFilter/filter-components/IntegerRangeFilter";

export const FilterGroup5 = () => {
  const baseKey =
    "pages.inventoryManagement.inventory.list.filters.filterGroup5";
  return (
    <FormGroup
      sx={{
        bgcolor: "customBackground.box",
        borderRadius: 1,
        mb: 2,
        padding: 2,
        display: "flex",
        gap: 2,
      }}
    >
      <IntegerRangeFilter
        name="supplier.cost"
        labelKey={`${baseKey}.amazonPrice`}
        adornment={"USD"}
      />
      <IntegerRangeFilter
        name="supplier.deliveryCost"
        labelKey={`${baseKey}.shippingCost`}
        adornment={"USD"}
      />
      <IntegerRangeFilter
        name="supplier.stock"
        labelKey={`${baseKey}.amazonStock`}
      />
      <IntegerRangeFilter
        name="marketplaceProduct.product.averageRating"
        labelKey={`${baseKey}.salesRank`}
      />
      <IntegerRangeFilter
        name="marketplaceProduct.product.ratingCount"
        labelKey={`${baseKey}.ratingCount`}
      />
      <IntegerRangeFilter
        name="sellerCount"
        labelKey={`${baseKey}.sellerCount`}
      />
    </FormGroup>
  );
};
